<template>
    <date-picker v-bind="$attrs" :format="format" :value="range" :first-day-of-week="1" :lang="lang" range v-on="listeners" @input="input" />
</template>

<script>
import { isDate, parse, format } from 'date-fns'
import DatePicker from 'vue2-datepicker'

const lang = {
    days: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
    months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
    pickers: ['+ Неделя', '+ Месяц', '- Неделя', '- Месяц'],
    placeholder: {
        date: 'Выберите дату',
        dateRange: 'Выберите временной интервал'
    }
}

export default {
    components: {
        DatePicker
    },

    inheritAttrs: false,

    props: {
        value: {
            type: Object,
            default: _ => ({ since: null, until: null })
        },

        format: {
            type: String,
            default: 'DD.MM.YYYY'
        },

        formatInput: {
            type: String,
            default: 'YYYY-MM-DD'
        }
    },

    computed: {
        since() {
            return this.value.since
        },

        until() {
            return this.value.until
        },

        sinceTrunc() {
            if (!this.since) {
                return null
            }

            return isDate(this.since) ? this.since : parse(this.since)
        },

        untilTrunc() {
            if (!this.until) {
                return null
            }

            return isDate(this.until) ? this.until : parse(this.until)
        },

        range() {
            return [ this.sinceTrunc, this.untilTrunc ]
        },

        listeners() {
            const { input, ...listeners } = this.$listeners
            return listeners
        },

        lang() {
            return lang
        }
    },

    methods: {
        input(value) {
            if (!value[0] || !value[1]) {
                return this.$emit('input', { since: null, until: null })
            }

            this.$emit('input', {
                since: isDate(this.since) ? value[0] : format(value[0], this.formatInput),
                until: isDate(this.until) ? value[1] : format(value[1], this.formatInput)
            })
        }
    }
}
</script>
